// SPDX-FileCopyrightText: Szilárd Hajba
// SPDX-License-Identifier: LGPL-3.0-or-later

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import hu from './i18n/hu/translation.json'

const resources = {
	en: {
		translation: {
			'Uploaded {{count}} file_one': 'Uploaded {{count}} file',
			'Uploaded {{count}} file_other': 'Uploaded {{count}} files',
			'Too many attempts. Please try again in about {{count}} minute_one':
				'Too many attempts. Please try again in about {{count}} minute',
			'Too many attempts. Please try again in about {{count}} minute_other':
				'Too many attempts. Please try again in about {{count}} minutes'
		}
	},
	hu: {
		translation: hu
	}
}

i18n.use(initReactI18next)
	.use(LanguageDetector)
	.init({
		resources,
		fallbackLng: 'en',
		keySeparator: '@',
		nsSeparator: '$',
		returnNull: false,
		// An untranslated key must fall back to its English text, not blank out the UI.
		returnEmptyString: false,
		react: {
			transSupportBasicHtmlNodes: true,
			transKeepBasicHtmlNodesFor: ['br', 'b', 'i', 'p']
		},
		// debug: true,
		// React escapes interpolated output on render, so i18next escaping it again
		// only turns a `/` in a path into a literal `&#x2F;` on screen.
		interpolation: {
			escapeValue: false
		}
	})
	.catch()

i18n.services.formatter?.add('uppercase', (value: string) => value.toUpperCase())
i18n.services.formatter?.add('number', (value: unknown, lng?: string) =>
	typeof value == 'number' ? Intl.NumberFormat(lng).format(value) : '-'
)
i18n.services.formatter?.add('price', (value: unknown, lng?: string) =>
	typeof value == 'number' ? Intl.NumberFormat(lng).format(value) + '-' : '-'
)

export default i18n

// vim: ts=4
